import { setOrganizationDimensions } from "../../../../../../features/trendsSlice";
import { TrendsDashboardEndPointLogic } from "../../../../../../logic/AssetManagement/Trends/TrendsDashboardEndPointLogic";

export const getCommonParams = async ({
  searchParams,
  userData,
  dispatch,
  oauthTokenHeader,
  store,
}: {
  searchParams: URLSearchParams;
  userData: any;
  dispatch: any;
  oauthTokenHeader: string;
  store: any;
}) => {
  const selectedSiteParam = searchParams.get("selectedSite");
  const dimensionParam = searchParams.get("dimension");
  const fetchByOrg = searchParams.get("fetchBy");

  const type = selectedSiteParam
    ? "site"
    : dimensionParam || fetchByOrg === "organization"
    ? "dimension"
    : "site";

  const website_shared_uid = selectedSiteParam
    ? selectedSiteParam.split(",")
    : [Object.keys(userData?.data?.website_permissions?.[0] || {})[0]];

  let dimensions: string[] = [];

  if (dimensionParam) {
    dimensions = dimensionParam.split(",");
  } else if (fetchByOrg === "organization") {
    await TrendsDashboardEndPointLogic.getDimentions(oauthTokenHeader);
    const orgName = userData?.data?.user_details?.organization_name;
    const allOrgData = store.getState().trends.organizationOptions;
    const matched = allOrgData
      .filter((org: any) => org.organization_id__organization_name === orgName)
      .map((org: any) => org.dimension);

    dispatch(
      setOrganizationDimensions(
        matched.map((uid: string) => ({ uid, siteName: uid }))
      )
    );

    dimensions = matched;
  } else {
    const defaultDimension = userData?.data?.dimensions?.[0];
    if (defaultDimension) dimensions = [defaultDimension];
  }

  return {
    type,
    website_shared_uid,
    dimensions,
  };
};
